import React, { useState } from 'react';
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-developer.png'
import development from '../../assets/images/svg/pixeltrue-web-development-1.svg'
import saas from '../../assets/images/saas/1.png'

import Navbar from "../../components/navbar";
import CompanyLogo from '../../components/companyLogo';
import Footer from '../../components/footer';
import ScrollTop from '../../components/scrollTop';

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

import { TypeAnimation } from 'react-type-animation';

import { developerPortfolio, principles } from '../../data/data';

import {FiArrowRight, MdOutlineFlip, LuFlipVertical2, LuRuler, FiTag } from '../../assets/icons/icons'

export default function IndexDeveloper(){
    let [isOpen, setOpen] = useState(false);
    return(
        <>
        <Navbar/>
        <section className="bg-half-170 d-table w-100" style={{backgroundImage: `url(${bg1})`}}>
            <div className="container">
                <div className="row align-items-center mt-5 mt-lg-0">
                    <div className="col-lg-5 col-md-6">
                        <div className="heading-title">
                            <h4 className="heading fw-bold">Creative & modern UI component for <br/>
                                <TypeAnimation
                                    sequence={[
                                        'developer',
                                        1000,
                                        'designer',
                                        1000,
                                        'freelancer',
                                        1000,
                                    ]}
                                    wrapper="span"
                                    speed={50}
                                    className="typewrite text-primary position-relative text-type-element"
                                    repeat={Infinity}
                                    cursor={false}
                                    />
                             </h4>
                            <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <div className="watch-video mt-4 pt-2">
                                <Link to="#" className="btn btn-primary">Learn More <i className="mdi mdi-chevron-right"></i></Link>
                                <Link to="#" onClick={() => setOpen(true)} className="lightbox video-play-icon watch text-dark ms-2"><i className="mdi mdi-play play-icon-circle text-center d-inline-block me-2 rounded-circle text-white position-relative play play-iconbar"></i> Watch now!</Link>
                            </div>
                            <ModalVideo
                                channel="youtube"
                                youtube={{ mute: 0, autoplay: 0 }}
                                isOpen={isOpen}
                                videoId="yba7hPeTSjk"
                                onClose={() => setOpen(false)} 
                            />
                        </div>
                    </div>
                    
                    <div className="col-lg-7 col-md-6">
                        <img src={development} className="img-fluid" alt=""/>
                    </div>
                </div>
            </div>
        </section>

        <section className="py-5 bg-light">
            <div className="container">
                <CompanyLogo/>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <span className="badge rounded-pill bg-soft-primary">Features</span>
                            <h4 className="title mt-3 mb-4">Landflow makes designing easy <br/> and performance fast</h4>
                            <p className="para-desc text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {principles.slice(0,3).map((item, index) =>{
                        let Icon = item.icon
                        return(
                            <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                                <div className="card border-0 features feature-primary">
                                    <div className="icon text-center rounded-md">
                                        <h3 className="mb-0"><Icon/></h3>
                                    </div>

                                    <div className="card-body p-0 mt-4">
                                        <h5>{item.title}</h5>
                                        <p className="text-muted">{item.desc}</p>
                                        <div className="mt-2">
                                            <Link to="#" className="link">Read More <FiArrowRight className="fea icon-sm"/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <img src={saas} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="ms-lg-5">
                            <div className="section-title">
                                <span className="badge rounded-pill bg-soft-primary">Components</span>
                                <h4 className="title mt-3 mb-4">Detailed block and <br/> component library</h4>
                                <p className="text-muted para-desc mb-0">Whether you’re building a simple page or coming up with concepts for a whole new web app, we’ve prepared the UI tools you need for an amazing development experience.</p>
                            </div>

                            <ul className="list-unstyled text-muted mb-0 mt-4">
                                <li className="list-inline-item me-lg-5 me-4"><span className="text-primary h3 me-2"><MdOutlineFlip /></span>Base Components</li>
                                <li className="list-inline-item me-lg-5 me-4"><span className="text-primary h3 me-2"><LuFlipVertical2/></span>Application Components</li>
                                <li className="list-inline-item me-lg-5 me-4"><span className="text-primary h3 me-2"><LuRuler /></span>Marketing Components</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <span className="badge rounded-pill bg-soft-primary">Portfolio</span>
                            <h4 className="title mt-3 mb-4">Beautiful collection of designer-made templates</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {developerPortfolio.map((item, index) =>{
                        return(
                            <div className="col-md-6 mt-4 pt-2" key={index}>
                                <div className="card work-container work-primary border-0 shadow rounded-md overflow-hidden">
                                    <div className="p-2">
                                        <Link to="#" className="text-danger"><i className="mdi mdi-circle"></i></Link>
                                        <Link to="#" className="text-warning"><i className="mdi mdi-circle"></i></Link>
                                        <Link to="#" className="text-success"><i className="mdi mdi-circle"></i></Link>
                                    </div>
                                    <div className="card-body content p-0">
                                        <img src={item.image} alt="" className="img-fluid mx-auto d-block border-bottom"/>

                                        <div className="content p-4">
                                            <h6><FiTag className="text-dark"/><Link to="#" className="text-muted ms-1 tag">{item.name}</Link></h6>
                                            <Link to={item.link} target="_blank" className="title text-dark h5">{item.title}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="row">
                    <div className="col-12 text-center mt-4 pt-2">
                        <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center">
                            <span className="badge rounded-pill bg-soft-primary">Subscribe</span>
                            <h4 className="title mt-3 mb-4">Want to be among the first to find out?</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        
                            <div className="subcribe-form mt-5">
                                <form>
                                    <div className="mb-0">
                                        <input type="email" id="email" name="email" className="border bg-white rounded" required placeholder="Enter your email address"/>
                                        <button type="submit" className="btn btn-primary">Notify me</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Footer/>
        <ScrollTop/>
        </>
    )
}